let stdoutWriteOverride: ((message: string) => void) | undefined;
let stdoutColumnsOverride: number | undefined;

/**
 * Set a function for TaskReporter to call instead of `process.stdout.write`.
 * This allows overriding *only* the TaskReporter output, not Jest's output.
 */
export function setStdoutOverride(stdoutOverride?: { write: (message: string) => void; columns: number }): void {
  stdoutWriteOverride = stdoutOverride?.write;
  stdoutColumnsOverride = stdoutOverride?.columns ?? 0;
}

export function write(message: string): void {
  if (stdoutWriteOverride) {
    stdoutWriteOverride(message);
  } else {
    process.stdout.write(message);
  }
}

export function getColumnsCount(): number {
  return stdoutColumnsOverride ?? process.stdout.columns;
}
